"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WebWorker = void 0;
var mmcq_1 = require("./mmcq");
Object.defineProperty(exports, "MMCQ", { enumerable: true, get: function () { return mmcq_1.default; } });
exports.WebWorker = null;
//# sourceMappingURL=index.js.map